/**
 *
 * PreLoad
 *
 * @version 1.0.0
 * @author Bartolo Amico
 * @since 13-Jan-2023
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Grid, Typography } from '@mui/material';
import PortalBody from 'Components/PortalBody';
import PortalContent from 'Components/PortalContent';
import Warning from 'Assets/images/svg/icon_warning.svg';
import style from './PreLoad.scss';
import formattedMessage from './languageModule';

const PreLoad = (props) => {
	const intl = useIntl();

	return (
		<>
			<PortalBody customStyle='noFooter'>
				<PortalContent className={style.content}>
					<Grid className={style.iconGif}>
						<img src={Warning} alt='Warning' />
					</Grid>
					<Typography className={style.title} variant='h3' align='center'>
						{intl.formatMessage(formattedMessage.title)}
					</Typography>
					<Typography className={style.message} variant='body1' align='center'>
						{intl.formatMessage(formattedMessage.section)}
					</Typography>
				</PortalContent>
			</PortalBody>
		</>
	);
};

PreLoad.propTypes = {
	// Add here some propTypes
	// and set a minimal description i.e.
	/** Description of prop "baz". */
};

PreLoad.defaultProps = {
	// Add here some default propTypes values
};

export default React.memo(PreLoad);
